import { FC, useState } from 'react';
import { Card, Col, DatePicker, Row } from 'antd';
import { useIntl } from 'react-intl';
import Chart from 'react-apexcharts';
import { useRentsPerMonthStats } from './useRentStatistics';
import { useRentsPerMonthChartOptions } from './useRentsChartOptions';
import moment from 'moment';

const YearRentsCard: FC = () => {
  const [selectedYear, setSelectedYear] = useState(
    moment(new Date().getFullYear(), 'YYYY'),
  );

  const { rentsPerMonth } = useRentsPerMonthStats(selectedYear.get('year'));
  const options = useRentsPerMonthChartOptions();
  console.log({ rentsPerMonth });
  const intl = useIntl();
  return (
    <Card className='hp-border-color-black-40 hp-card-6 hp-chart-text-color'>
      <Row>
        <Col className='hp-mb-16' span={24}>
          <Row justify='space-between'>
            <Row align='bottom'>
              <h4 className='hp-mr-8'>Faturação e Recebimentos</h4>
            </Row>

            <Col>
              <DatePicker
                picker='year'
                value={selectedYear}
                onChange={(value) => value && setSelectedYear(value)}
              />
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <div id='revenue-column-card'>
            <Chart
              type='line'
              options={{ ...options.paymentValue }}
              series={[
                {
                  data:
                    rentsPerMonth?.map((monthRents) =>
                      monthRents.reduce(
                        (prev, curr) => prev + curr.paymentTotal,
                        0,
                      ),
                    ) || [],
                  name: 'Faturação',
                },
                {
                  data:
                    rentsPerMonth?.map((monthRents) =>
                      monthRents
                        .filter((rent) => rent.payed)
                        .reduce((prev, curr) => prev + curr.paymentTotal, 0),
                    ) || [],
                  name: 'Recebimentos',
                },
              ]}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default YearRentsCard;
